<template>
  <section class="view-compare">
    <p class="print-disclaimer">Disclaimer: This is a snapshot of the Tech Platform Assistant. Please note this tool is updated regularly; you can visit the live site for the most current information.</p>
    <section
      :class="[
        'compare',
        'compare--chosen--' + chosenPlatforms.length
      ]"
    >
      <section class="compare__head">
        <h2>Compare<span class="mobile-hide"> Platforms</span></h2>
        <a
          @click.prevent="goBackEvent"
          href="#"
          class="link--go-back"
        >
          Go Back
        </a>

        <section class="chosenPlatforms">
          <div
            :key="platform['.key']"
            v-for="platform in chosenPlatforms"
            class="chosenPlatforms__header"
          >
            {{ platform.displayName }}
            <span
              class="chosenPlatforms__remove"
              @click="removePlatformEvent(platform)"
            >Remove Platform</span>
          </div>
        </section>
      </section>

      <section class="compare__body">
        <div class="compare__v-bar-content">
          <div class="body__content">
            <section class="feature-sections">
              <section
                v-for="(section) in featureSections"
                :key="section['.key']"
                :class="[
                  {
                    'feature-section': true,
                    'feature-section--collapsed': settings.featureCollapse[section['.key']],
                    'print-hide': section.displayName === 'Pricing' || section.displayName === 'Sales Contact' || section.displayName === 'Propr Path'
                  },
                  'feature-section--' + section['.key']
                ]"
              >
                <div class="feature-section__head">
                  <h3 class="feature-section__title" @click="toggleFeatureEvent(section['.key'], section.displayName, settings.featureCollapse[section['.key']])">
                    {{ section.displayName }}
                    <span
                      :class="[
                        'button',
                        'button--blue',
                        'button--small',
                        'button--outline',
                        {'button--hover': settings.featureCollapse[section['.key']]}
                      ]"
                    >
                      {{settings.featureCollapse[section['.key']] ? 'Show' : 'Hide'}}
                    </span>
                  </h3>
                </div>
                <div class="feature-section__body">
                  <table
                    :class="[
                      'features-table',
                      'features-table--' + section['.key']
                    ]"
                  >
                    <tr v-for="(feature) in sortFeatures(section.features)" :key="feature['.key']">
                      <td class="features-table__cell">
                        <div class="features-table__cell-content">{{ feature.displayName }}</div>
                      </td>
                      <td
                        class="features-table__cell-value"
                        v-for="platform in chosenPlatforms"
                        :key="platform['.key']"
                      >
                        <template v-if="feature && feature.notesOnly">
                          <div class="features-table__cell-value--notes-only">
                            <template v-if="platform.features[feature['.key']]">
                              <span
                                class="feature-note"
                                @click.prevent="handleClick($event)"
                                v-html="platform.features[feature['.key']].notes ?
                                  platform.features[feature['.key']].notes.trim() : ''"
                              ></span>
                            </template>
                          </div>
                        </template>
                        <template v-else>
                          <div class="features-table__cell-value--flex">
                            <template v-if="platform.features[feature['.key']]">
                              <unum-icon
                                icon="check"
                                v-if="platform.features[feature['.key']].available === true"
                              />
                              <unum-icon
                                icon="x-gray"
                                v-if="platform.features[feature['.key']].available === null || platform.features[feature['.key']].available === false"
                              />
                              <span
                                class="availability-unknown"
                                v-if="platform.features[feature['.key']].available === 'unknown'"
                              >
                                Unknown
                              </span>
                              <unum-icon
                                icon="info"
                                v-if="platform.features[feature['.key']].notes"
                                v-tooltip="platform.features[feature['.key']].notes.trim() || ''"
                              />
                              <p
                                v-if="platform.features[feature['.key']].notes"
                                class="print-tooltip"
                              >Note: {{ platform.features[feature['.key']].notes.trim() || '' }}</p>
                            </template>
                            <template v-else>
                              <unum-icon icon="x-gray" />
                            </template>
                          </div>
                        </template>
                      </td>
                      <template v-if="chosenPlatforms.length < 3">
                        <td
                          class="features-table__cell-value"
                          v-for="index in (3 - chosenPlatforms.length)" :key="index"
                        >
                        </td>
                      </template>
                    </tr>
                  </table>
                </div>
              </section>

              <template v-for="platform in chosenPlatforms">
                <section
                  v-if="platform.platformNotes"
                  class="feature-section__special-programs"
                  :key="platform['.key']"
                >
                  <table
                    :class="[
                      'features-table'
                    ]"
                  >
                    <tr>
                      <td class="features-table__cell">
                        <div class="features-table__cell-content">Special Programs</div>
                      </td>
                      <td
                          class="features-table__cell-value"
                          v-for="platform in chosenPlatforms"
                          :key="platform['.key']"
                        >
                        {{ platform.platformNotes }}
                      </td>
                      <template v-if="chosenPlatforms.length < 3">
                        <td
                          class="features-table__cell-value"
                          v-for="index in (3 - chosenPlatforms.length)" :key="index"
                        >
                        </td>
                      </template>
                    </tr>
                  </table>
                </section>
              </template>
            </section>
          </div>
        </div>

        <template v-if="chosenPlatforms.length < 3">
          <section
            :class="['platformPlaceholder', 'platformPlaceholder--' + index]"
            v-for="index in (3 - chosenPlatforms.length)" :key="index"
          >
            <p>Add a Platform</p>
            <span
              :id="`add-platform-button-${index}`"
              @click="addPlatformEvent"
              class="platformPlaceholder__add"
            >Add a Platform</span>
            <!-- <router-link
              v-if="!filteredPlatforms.length"
              :to="{ name: 'Wizard' }"
            >
              <unum-button
                small
                outline
                color="blue"
              >
                Help Me Choose
              </unum-button>
            </router-link> -->
          </section>
        </template>
      </section>

      <section class="compare__footer">
        <section class="chosenPlatformsActions">
          <div
            :key="platform['.key']"
            v-for="platform in chosenPlatforms"
            class="chosenPlatformsActions__cta"
          >
            <unum-button
              small
              outline
              color="dark-blue"
              @click.native="finalSelection(platform)"
            >
              What's Next?
            </unum-button>
          </div>
        </section>
      </section>
    </section>
    <drawer-compare-selector />
  </section>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import { db } from '@/appConfig/appConfig'
import UnumButton from '@/components/ui/Button'
import UnumIcon from '@/components/ui/Icon'
import DrawerCompareSelector from '@/components/layout/DrawerCompareSelector'
import sessionEvent from '@/util/sessionEvent'

export default {
  name: 'Compare',
  components: {
    UnumButton,
    UnumIcon,
    DrawerCompareSelector
  },
  data () {
    return {
      featureSections: []
    }
  },
  async created () {
    const featureSettings = await db.ref('blueprints/sections').once('value')
      .then(function (featureSectionsBlueprint) {
        let featureSettings = {}
        Object.entries(featureSectionsBlueprint.val())
          .forEach(featureKey => {
            featureSettings[featureKey[0]] = featureKey[1].collapsed
          })
        return featureSettings
      })
    this.$store.dispatch('shared/setFeatureSectionSettings', featureSettings)
  },
  mounted () {
    if (this.filteredPlatforms.length > 0 && this.chosenPlatforms.length < 3) {
      setTimeout(() => {
        this.openCompareDrawerSelector()
      }, 1000)
    }
  },
  firebase: {
    featureSections: db.ref('blueprints/sections').orderByChild('weight')
  },
  methods: {
    ...mapActions('shared', [
      'toggleFeature',
      'toggleCompareDrawerSelector',
      'openCompareDrawerSelector'
    ]),
    ...mapActions('platforms', [
      'removePlatform',
      'platformSelection',
      'clearChosenPlatforms',
      'clearCurrentPlatform'
    ]),
    ...mapActions('wizard', [
      'clearWizard'
    ]),
    featuresByWeight (featureSection) {
      let sorted = Object.values(featureSection).sort(function (a, b) {
        return a.weight - b.weight
      })

      return sorted
    },
    sortFeatures (featuresObject) {
      const result = Object.entries(featuresObject)
        .map((feature) => {
          return {
            '.key': feature[0],
            ...feature[1]
            // displayName: feature[1].displayName,
            // weight: feature[1].weight
          }
        })
      return this.featuresByWeight(result)
    },
    toggleDrawer () {
      this.toggleCompareDrawerSelector()
    },
    finalSelection (platform) {
      console.log('FINAL SELECTION!!! - ' + platform.displayName)
      const sessionKey = this.$storage.get('session_key')
      sessionEvent(sessionKey, 'made_final_selection',
        {
          platform: platform.displayName,
          platformKey: platform['.key']
        }, { fromPath: 'Compare' })

      this.platformSelection(platform)
      this.$router.push({ name: 'FinalSelection' })
    },
    addPlatformEvent () {
      const sessionKey = this.$storage.get('session_key')
      sessionEvent(sessionKey, 'clicked_compare_add_platform_button')
      this.toggleDrawer()
    },
    removePlatformEvent (platform) {
      const sessionKey = this.$storage.get('session_key')
      sessionEvent(sessionKey, 'clicked_compare_remove_platform_button', { platform: platform.displayName })
      this.removePlatform(platform)
    },
    toggleFeatureEvent (sectionKey, sectionDisplayName, sectionToggleState) {
      const sessionKey = this.$storage.get('session_key')
      sessionEvent(sessionKey, 'toggle_compare_platform_section', {
        section: sectionDisplayName,
        toggle_state: sectionToggleState ? 'open' : 'closed'
      })
      this.toggleFeature(sectionKey)
    },
    goBackEvent () {
      const sessionKey = this.$storage.get('session_key')
      sessionEvent(sessionKey, 'clicked_back_link', {
        to: this.$store.state.route.from.fullPath
      })
      this.$router.go(-1)
    },
    handleClick (e) {
      if (Element.prototype.msMatchesSelector) {
        if (e.target.msMatchesSelector('a')) {
          window.open(e.target.getAttribute('href'))
        }
      } else {
        if (e.target.matches('a')) {
          window.open(e.target.getAttribute('href'))
        }
      }
    }
  },
  computed: {
    ...mapState('platforms', [
      'chosenPlatforms'
    ]),
    ...mapState('shared', [
      'settings'
    ]),
    ...mapState('wizard', [
      'filteredPlatforms'
    ])
  },
  beforeRouteEnter: (to, from, next) => {
    if (from.name === 'Lookup') {
      next(vm => {
        vm.clearWizard()
      })
      return
    }
    next()
  },
  beforeRouteLeave (to, from, next) {
    console.warn(this.filteredPlatforms.length)
    if (this.filteredPlatforms.length > 0) {
      if (to.name === 'FinalSelection' || to.name === 'WizardSummary') {
        next()
        return
      }

      this.$modal.show('dialog', {
        title: 'Caution',
        text: `By navigating away, you will lose any selections or results so far.`,
        buttons: [
          {
            title: 'Cancel',
            handler: () => {
              this.$modal.hide('dialog')
            }
          },
          {
            title: 'Ok',
            handler: () => {
              this.clearWizard()
              this.clearChosenPlatforms()
              this.clearCurrentPlatform()
              this.$modal.hide('dialog')
              next()
            }
          }
        ]
      })
    } else {
      // this.clearCurrentPlatform()
      // this.clearChosenPlatforms()
      next()
    }
  }
}
</script>

<style lang="scss" scoped>

.view-compare {
  @media print {
    overflow: visible;
    position: static !important;
    height: auto;
  }
  .icon--info {
    @media print {
      display: none;
    }
  }
  .feature-note {
    @media print {
      display: block;
      text-align: left !important;
      font-weight: normal !important;
      font-size: rem(10px) !important;
      line-height: 1.2 !important;
    }
  }
}

.compare {
  position: relative;
  overflow: auto;
  // height: calc(100% - 8rem - 4rem);
  height: 100%;

  @media print {
    overflow: visible;
    height: auto;
  }

  &__head {
    // height: 128px;
    height: 4.688rem;
    background: $lightBlue;
    padding: .75rem 2rem;
    display: flex;
    flex-flow: column nowrap;
    align-items: flex-start;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.25);
    position: relative;
    z-index: 1;

    @include bp($small) {
      padding: .75rem 3rem;
    }

    @media print {
      height: auto;
      padding: 0.75rem 1.5rem;
    }

    h2 {
      color: $blue;
      font-weight: 600;
      margin: 0;
      order: 1;
    }

    .unum-field {
      max-width: calc(50% - 1rem);
      margin: 0 1rem 0 0;
    }
  }

  &__body {
    overflow: auto;
    height: calc(100% - 4.688rem - 3.125rem);
    background: #fff;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none;  /* IE 10+ */
    &::-webkit-scrollbar { /* Chrome, Safari */
      width: 0;
      background: transparent;
    }
    @media print {
      overflow: visible;
      height: auto;
    }
  }

  &__footer {
    height: 3.125rem;
    background: #FFB47D;
    @media print {
      display: none;
    }
  }
}

.feature-sections {
  width: 100%;
}

.feature-section {
  &--collapsed {
    .feature-section__body {
      transition: max-height .25s ease;
      max-height: 0;
    }
  }

  & + .feature-section {
    border-top: .063rem solid #D8E5EE;
  }

  &__head {
    // z-index: 1;
    position: relative;
    background-color: #D8E5EE;
  }

  &__body {
    transition: all .5s ease;
    max-height: 420rem;
    overflow: hidden;
    @media print {
      max-height: none !important;
    }
  }

  &__title {
    margin: 0;
    background: $lightBlue;
    padding: 1rem 1.5rem;
    color: $blue;
    cursor: pointer;

    display: flex;
    justify-content: space-between;
    align-items: center;
    width: calc(34% + 2px);

    .button {
      flex: 0 0 auto;
      @include bp($small, 'max-width') {
        display: none;
      }
      @media print {
        display: none;
      }
    }

    .compare--chosen--1 & {
      width: calc(34% + 22% + 2px);
    }

    .compare--chosen--2 & {
      width: calc(34% + 44% + 2px);
    }

    .compare--chosen--3 & {
      width: 100%;
    }
  }

  &--sales_contact {
    .features-table {
      td {
        &.features-table__cell-value {
          word-break: break-all;
          // @include bp($large) {
          //   word-break: none;
          // }
        }
      }
    }
  }
}

.features-table {
  width: 100%;
  border-collapse: collapse;

  &__cell-content {
    @media print {
      width: rem(180px);
    }
  }

  tr {
    break-inside: avoid;
  }

  td {
    padding: .5rem 1.5rem;
    border-bottom: .063rem solid $lightBlue;
    font-weight: 600;
    color: $superDarkBlue;
    font-size: .875rem;
    word-break: break-word;
    @include bp($medium) {
      padding: .5rem 2.25rem;
    }

    &.features-table__cell {
      width: 34%;
    }

    &.features-table__cell-value {
      text-align: center;
      width: 22%;
      padding: 0.3rem;

      @include bp($medium) {
        padding: 0.25rem 1rem;
      }

      &--flex,
      &--notes-only {
        display: flex;
        align-items: center;
        margin: 0 auto;
      }

      &--flex {
        max-width: 6rem;

        .icon--check {
          margin-right: auto;
          justify-self: flex-start;
        }
        .icon--info,
        .button {
          margin-left: auto;
          justify-content: flex-end;
        }
      }

      &--notes-only {
        .feature-note {
          flex: 0 0 100%;
        }
      }

      & + .features-table__cell-value {
        border-left: .063rem solid #D8E5EE;
      }
    }

    .features-table__cell-value--flex {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &:first-child {
      border-right: .063rem solid #D8E5EE;
    }
  }
  .availability-unknown {
    font-size: 0.5625rem; // 9px
    @include bp($medium) {
      font-size: 0.875rem;
    }
  }
}

.chosenPlatforms {
  width: calc(66% - .063rem);
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;

  &__header {
    width: 33.3333%;
    padding: 0.5rem 0.3rem;
    color: #fff;
    font-weight: 600;
    font-size: 0.6rem;
    background: #347983;
    text-align: center;
    position: relative;

    @include bp($small) {
      padding: 0.5rem 1.5rem 0.5rem 0.3rem;
    }

    @include bp($medium) {
      padding: 0.5rem 1.75rem 0.5rem 0.5rem;
      font-size: .875rem;
    }

    @include bp($large) {
      padding: 0.65rem 1.75rem 0.65rem 0.65rem;
    }

    @media print {
      color: #FFF !important;
    }

    &:nth-child(2) {
      color: $steelblue3;
      background: $leaf;
      .chosenPlatforms__remove {
        background-color: $leaf;
        background-image: url('~@/assets/images/ui/x-steelblue3.svg');
        // outline: 2px solid #83ab22;
      }
    }

    &:nth-child(3) {
      color: $steelblue3;
      background: $orange;
      .chosenPlatforms__remove {
        background-color: $orange;
        background-image: url('~@/assets/images/ui/x-steelblue3.svg');
        // outline: 2px solid #7e2826;
      }
    }

  }

  &__remove {
    display: block;
    width: .8rem;
    height: .8rem;
    background: url('~@/assets/images/ui/x-white.svg') center center no-repeat;
    background-size: 75% auto;
    position: absolute;
    text-indent: -9999px;
    right: 0;
    bottom: 100%;
    background-color: #1A809C;
    // outline: 2px solid #3BAECC;
    cursor: pointer;

    @include bp($small) {
      bottom: auto;
      right: 0.3rem;
      top: 50%;
      width: .75rem;
      height: .75rem;
      background-size: contain;
      transform: translateY(-50%);
    }

    @include bp($medium) {
      right: 0.5rem;
    }
  }
}

.chosenPlatformsActions {
  width: calc(66% - .063rem);
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  height: 37px;

  @include bp($medium) {
    height: 50px;
  }

  &__cta {
    width: calc(33.333% + .063rem);
    color: #fff;
    font-weight: 600;
    font-size: .875rem;
    text-align: center;
    position: relative;
    background: transparent;

    .compare--chosen--3 & {
      width: calc(33.333% + .063rem);
    }

    .compare--chosen--3 &:nth-child(2) {
      width: calc(33.333% + 3px);
    }

    .compare--chosen--3 &:last-child {
      width: calc(33.333% - .063rem);
    }

    .button {
      width: 60px;
      padding: .25rem 0.5rem;
      @include bp($medium) {
        width: auto;
        padding: .25rem 1rem;
      }
    }

  }

  &__remove {
    width: .75rem;
    height: .75rem;
    background: url('~@/assets/images/ui/x-white.svg') center center no-repeat;
    background-size: contain;
    position: absolute;
    text-indent: -9999px;
    right: 1rem;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
  }
}

.platformPlaceholder {
  background: #fff;
  position: absolute;
  // width: calc(22% - .063rem);
  width: 22%;
  height: 100%;
  top: 0;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  border-left: .063rem solid $lightBlue;

  &--1 {
    // right: -.063rem;
    right: 0;
  }

  &--2 {
    // right: calc(22% - .063rem);
    right: calc(22%);
  }

  &--3 {
    // right: calc(44% - .063rem);
    right: calc(44%);
  }

  p {
    text-align: center;
    color: $grey;
    font-weight: 600;
    @media print {
      display: none;
    }
  }

  &__add {
    padding: 2rem;
    height: 2rem;
    width: 2rem;
    border-radius: 50%;
    text-indent: -9999px;
    position: relative;
    cursor: pointer;
    margin-bottom: 1rem;

    @include bp($medium) {
      height: 7rem;
      width: 7rem;
    }

    @media print {
      display: none;
    }

    &:after {
      content: '';
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background-image: url('~@/assets/images/add-btn.svg');
      background-size: 35%;
      background-position: center center;
      background-repeat: no-repeat;

      @include bp($medium) {
        background-size: auto;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Compare.vue